export default __webpack_public_path__ + "static/media/FOOTER.350d085c.jpg";